module.exports = __webpack_public_path__ + "img/Weapon_49.74fb12a1.png";